// import Vue from 'vue'

const searchTuneOption = {
  state: {
    scenes: [
      { id: 1, sceneName: 'フラワーシャワー', avatar: '/static/icon/ico1.png' },
      { id: 2, sceneName: 'アフターセレモニー', avatar: '/static/icon/ico2.png' },
      { id: 3, sceneName: '披露宴入場', avatar: '/static/icon/ico3.png' },
      { id: 4, sceneName: '乾杯', avatar: '/static/icon/ico4.png' },
      { id: 5, sceneName: 'ケーキ入刀', avatar: '/static/icon/ico5.png' },
      { id: 6, sceneName: '新婦中座', avatar: '/static/icon/ico6.png' },
      { id: 7, sceneName: '新郎中座', avatar: '/static/icon/ico7.png' },
      { id: 8, sceneName: 'お色直し入場', avatar: '/static/icon/ico8.png' },
      { id: 9, sceneName: 'メイン演出', avatar: '/static/icon/ico9.png' },
      { id: 10, sceneName: '手紙朗読', avatar: '/static/icon/ico10.png' },
      { id: 11, sceneName: '花束贈呈', avatar: '/static/icon/ico11.png' },
      { id: 12, sceneName: '退場', avatar: '/static/icon/ico12.png' }
    ],
    scenesRanking: [
      { id: 0, sceneName: '総合ランキング', avatar: '' },
      { id: 1, sceneName: 'フラワーシャワー', avatar: '/static/icon/ico1.png' },
      { id: 2, sceneName: 'アフターセレモニー', avatar: '/static/icon/ico2.png' },
      { id: 3, sceneName: '披露宴入場', avatar: '/static/icon/ico3.png' },
      { id: 4, sceneName: '乾杯', avatar: '/static/icon/ico4.png' },
      { id: 5, sceneName: 'ケーキ入刀', avatar: '/static/icon/ico5.png' },
      { id: 6, sceneName: '新婦中座', avatar: '/static/icon/ico6.png' },
      { id: 7, sceneName: '新郎中座', avatar: '/static/icon/ico7.png' },
      { id: 8, sceneName: 'お色直し入場', avatar: '/static/icon/ico8.png' },
      { id: 9, sceneName: 'メイン演出', avatar: '/static/icon/ico9.png' },
      { id: 10, sceneName: '手紙朗読', avatar: '/static/icon/ico10.png' },
      { id: 11, sceneName: '花束贈呈', avatar: '/static/icon/ico11.png' },
      { id: 12, sceneName: '退場', avatar: '/static/icon/ico12.png' },
      { id: 13, sceneName: '歓談', avatar: '/static/icon/ico13.png' }
    ],
    tags: [
      { id: 1, tagName: 'アップテンポ' },
      { id: 2, tagName: 'バラード' },
      { id: 3, tagName: '明るい' },
      { id: 4, tagName: 'キュート' },
      { id: 5, tagName: 'さわやか' },
      { id: 6, tagName: '和' },
      { id: 7, tagName: 'エレガント' },
      { id: 8, tagName: 'モダン' },
      { id: 9, tagName: 'ナチュラル' },
      { id: 10, tagName: 'クラシック' },
      { id: 11, tagName: 'ジャズ' },
      { id: 12, tagName: 'ボーカル' },
      { id: 13, tagName: 'インスト' },
      { id: 14, tagName: '英詞' }
    ],
    infiniteLoadingFlg: false
  },
  mutations: {
    searchInfiniteLoadingFlg (state, flag) {
      state.infiniteLoadingFlg = flag
    }
  },
  actions: {
  },
  getters: {
    getSceneObjectById: (state) => (sceneId) => {
      let index = sceneId - 1
      if (index < 0 || index > 14) {
        return ''
      } else {
        return state.scenes[index]
      }
    },
    getSearchInfiniteLoadingFlg (state) {
      return state.infiniteLoadingFlg
    }
  }
}
export default searchTuneOption



// WEBPACK FOOTER //
// ./src/store/searchTuneOption.js